module.exports = __webpack_public_path__ + "img/rbs.600b29c2.svg";